// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mental-health-screening-with-background.svg';

export const MentalHealthScreeningWithBackground = (props: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        style={{ width: 43, height: 43 }}
        {...props}
    />
);
